import React, { FC, useEffect, useState } from 'react';

import { NativeResources } from '@ariksa/inventory-core';
import { Box, useDisclosure } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';

import { CustomTable2 as Table } from 'components/DataDisplay/NewTable/Table';
import { MetadataTabs } from 'containers/ActiveCloudResource/types';
import { useVulnerabilityContext } from 'containers/Visibility/Vulnerabilities/Components/hooks/context';
import { useVulnerabilityTableColumns } from 'containers/Visibility/Vulnerabilities/Components/hooks/useVulnerabilityTableColumns';
import { ResourceVulnerabilityDrawer } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ResourceVulnerabilityDrawer';
import { selectVulnerabilities } from 'containers/Visibility/Vulnerabilities/selectors';

import { actions } from '../../slice';

export const ResourceVulnerabilities: FC = () => {
  const dispatch = useDispatch();
  const { vulnerabilities, resourceType } = useSelector(selectVulnerabilities);
  const {
    tableColumns,
    tableActionModals,
    handleRowClick,
  } = useVulnerabilityTableColumns();
  const { getResourceVulnerabilities } = useVulnerabilityContext();
  const vulnerabilityDisclosure = useDisclosure();
  const [currentRecord, setCurrentRecord] = useState<Record<string, any>>({});

  useEffect(() => {
    getResourceVulnerabilities();
  }, [getResourceVulnerabilities]);
  return (
    <>
      <Box h="full">
        <Table
          data={vulnerabilities.data}
          isError={vulnerabilities.isError}
          columns={tableColumns}
          isLoading={vulnerabilities.isLoading}
          cursor="pointer"
          styles={{ header: { position: 'relative', zIndex: 800 } }}
          onRowClick={r => {
            if (resourceType === NativeResources.ElasticContainerRegistry)
              handleRowClick(r, MetadataTabs.ContainerImages);
            else vulnerabilityDisclosure.onOpen();
            setCurrentRecord(r);
          }}
          pagination={{
            pageInfo: vulnerabilities.page.info,
            onChange: info =>
              dispatch(actions.updateVulnerabilityPageInfo(info)),
            totalCount: vulnerabilities.page.totalCount,
          }}
        />
      </Box>
      {tableActionModals}
      {vulnerabilityDisclosure.isOpen && (
        <ResourceVulnerabilityDrawer
          isOpen={vulnerabilityDisclosure.isOpen}
          onClose={vulnerabilityDisclosure.onClose}
          uuid={currentRecord.uuid}
        />
      )}
    </>
  );
};
